// Ruft den PLZ-AJAX Controller auf wenn das Feld "inputFieldId" geändert wird.
// Das Ergebnis ist eine Liste mit Orten zu der eingegbenen PLZ. Die Orte werden in das Dropdown "ResultElementId" gefüllt.
// Die Methode handlePLZResponse kann in der JSP überschrieben werden wenn ein anderes Verhalten erwünscht wird.
// Dies muss nach dem Include der JS Datei geschehen. zb:
// function handlePLZResponse(data, resultElementId) {
//	 alert("elem: " + resultElementId);
// }

// Parameter:
// resultElementId:  ID der Dropdown-Liste die mit dem Ergebnis befüllt wird. 
// inputFieldId:     ID des Eingabefeldes das den AJAX Request auslöst.
// infoFieldId:      ID des Feldes in das die OK/Fehlermeldun geschrieben wird.
// ladekringelId:    ID Der Ladekringel-Grafik
// url:			  	 URL des PLZ Services, muss in der inkludierenden JSP deklariert werden

// Wenn value von aktuellerOrt1 undefined ist, wird das in callPLZService durch ortDropdown1.val() ersetzt. 
// Somit bitte ortInputSpan1 und aktuellerOrt1 bestehen lassen, 
// auch wenn Land manchmal als Österreich vordefiniert wird und dadurch beide Felder als überflüssig erscheinen würden.


function handlePLZResponse(data, resultElementId) {
	try {
		var fonMsg = jQuery.parseJSON(data);
		var ortDropDown = $(resultElementId);
		ortDropDown.empty();
		
		$.each(fonMsg.ortsliste, function(k,v) {
		    ortDropDown.append($("<option />").val(k).text(v));
		});
	} catch(e) {
	    fonMsg.code = "Postleitzahl ungültig";
		//alert("Fehler beim Lesen der Ortschaften. " + e);
	}	
	return fonMsg;
}

export function initOrtInput(landId, ortInputId, ortDropdownClass) {
	$(ortDropdownClass).hide();
	$(ortInputId).hide();
	handleOrtInput(landId, ortInputId, ortDropdownClass);

	$(landId).change(function() {
			handleOrtInput(landId, ortInputId, ortDropdownClass);
		}
	);
	
}
function handleOrtInput(land, ortInput, ortDropdownClass) {
	if($(land).val() == "A" || $(land).val() == "AT") {
		$(ortDropdownClass).show();
		$(ortDropdownClass).prop("disabled", false);
		$(ortInput).hide();
		$(ortInput).prop("disabled", true);
	} 
	else  {
		$(ortDropdownClass).prop("disabled", true);
		$(ortDropdownClass).hide();
		$(ortInput).prop("disabled", false);
		$(ortInput).show();
	}
}

function handleAjax(resultElementId, inputFieldId, infoFieldId, ladekringelId, landId, previousOrt) {
	$(infoFieldId).hide();
	if((landId == null || $(landId).val() == "A" || $(landId).val() == "AT")) {
		var inputValue = $.trim($(inputFieldId).val());
		if (!inputValue || inputValue.length == 0) {
			// plz input ist leer!
			$(resultElementId).empty();
		} else {
			$('input[type=submit]').attr("disabled", "disabled");
			$(ladekringelId).css("visibility", "visible");
			var ajaxData = "plz="+$(inputFieldId).val();
			$.ajax( {
				url: urlPlzService,
				timeout: 10000,
				  data: ajaxData,
				  scriptCharset: "iso-8859-1" ,
				  contentType: "text/html; charset=iso-8859-1",
				  dataType: 'text',
				  success: function(data) {
					var fonMsg = handlePLZResponse(data, resultElementId);
					if (typeof(previousOrt) === "undefined" || !previousOrt){
						var previousOrt2 = resultElementId.val();
						selectPreviousOrt(resultElementId, previousOrt2);
					}
					else{
						selectPreviousOrt(resultElementId, previousOrt);
					}
					$(ladekringelId).css("visibility", "hidden");
					if(fonMsg.ok=='true') {
						$(infoFieldId).html(fonMsg.code);
						$(infoFieldId).css("color", "green");
						$(infoFieldId).show();
					} else { 
						$(infoFieldId).html(fonMsg.code);
						$(infoFieldId).css("color", "red");
						$(infoFieldId).show();
					}
					if(fonMsg.allowSubmit=="true") {
						$('input[type=submit]').removeAttr("disabled");
					}
				},
				error: function(jqXHR, textStatus, errorThrown){
					$(ladekringelId).css("visibility", "hidden");
					$(infoFieldId).html("Postleitzahl ungültig");
					$(infoFieldId).css("color", "red");
					$(infoFieldId).show();
					$('input[type=submit]').removeAttr("disabled");	
				}
			}); 
		}
	}
}
export function callPLZService(resultElementId, inputFieldId, infoFieldId, ladekringelId, landId, previousOrt) {
	$(inputFieldId).on('change', function(){
		if (typeof(previousOrt) === "undefined" || !previousOrt){
			var previousOrt2 = resultElementId.val();
			handleAjax(resultElementId, inputFieldId, infoFieldId, ladekringelId, landId, previousOrt2);
		}
		else{
			handleAjax(resultElementId, inputFieldId, infoFieldId, ladekringelId, landId, previousOrt);
		}
	});
	$(landId).on('change', function(){
		if (typeof(previousOrt) === "undefined" || !previousOrt){
			var previousOrt2 = resultElementId.val();
			handleAjax(resultElementId, inputFieldId, infoFieldId, ladekringelId, landId, previousOrt2);
		}
		else{
			handleAjax(resultElementId, inputFieldId, infoFieldId, ladekringelId, landId, previousOrt);
		}
	});
}

function selectPreviousOrt(ortDropdown, previousOrt){
	ortDropdown.find('option').each(function() {
		if ($(this).val() == previousOrt){
			this.selected = previousOrt;
		}
	})
}
